import {getDataWithPromise, Globals, handleAjaxError} from "./BaseDataFns";

export const submitProviderLogo = ( provider_id, data, onComplete ) =>
{
    let url = Globals.APIFolder + '/providers/' + provider_id + '/logo';

    getDataWithPromise ( url, 'POST', { data: data } )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}
